import { projects } from '../constants';
import { SectionWrapper } from '../hoc';
import { styles } from '../styles';
import ProjectDrawer from './Projects/ProjectDrawer';

const Gallery = () => {
  return (
    <>
      <div>
        <div className={`${styles.sectionHeadText}`}>Projects </div>
        <div className="mt-12">
          <div className="mb-4 text-center text-txt-secondary pb-2 border-b border-tertiary">
            Click on a project to view details{' '}
          </div>
          <div className=" mx-auto gap-8 grid lg:grid-cols-3 sm:grid-cols-2 md:gap-y-12">
            {projects.map((item, idx) => (
              // <ProjectDialog key={idx} {...item} />
              <ProjectDrawer key={idx} {...item} />
            ))}
          </div>
          {/* <div className="mt-4 text-center text-txt-secondary pb-2 border-t-2 border-tertiary"></div> */}
        </div>
      </div>
    </>
  );
};

export default SectionWrapper(Gallery, 'projects');
